export default "__VITE_ASSET__BOyJwTpM__"